













































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class EquipmentCard extends Vue {
    @Prop({ required: true })
    equipmentItem!: any;

    @Prop({ required: true })
    deletePrivilege!: boolean;

    @Prop({ required: true })
    updatePrivilege!: boolean;

    datacenterTab: number = 0;
    menu: boolean = false;

    @Emit('deleteEquipment')
    deleteEquipment(buildingEquipmentIds, equipmentName) {
        this.$emit('deleteEquipment', buildingEquipmentIds, equipmentName);
    }
    @Emit('updateEquipment')
    updateEquipment(equipment) {
        this.$emit('updateEquipment', equipment);
    }

    get equipment() {
        let equipment: {
            id: number;
            name: string;
            parameters: {
                id: number;
                name: string;
                measureUnit: string;
            }[];
            dataCenters: {
                id: number;
                name: string;
                buildingDataCenter: {
                    id: number;
                    building: {
                        id: number;
                        name: string;
                    };
                }[];
            }[];
        } = {
            id: -1,
            name: '',
            parameters: [],
            dataCenters: [],
        };

        if (this.equipmentItem) {
            equipment.id = this.equipmentItem.id;
            equipment.name = this.equipmentItem.name;
            this.equipmentItem.buildingEquipments[0].parametersEquipments.forEach(
                parameterEquipment => {
                    let parameter: {
                        id: number;
                        name: string;
                        measureUnit: string;
                    } = {
                        id: parameterEquipment.parameter.id,
                        name: parameterEquipment.parameter.name,
                        measureUnit: parameterEquipment.parameter.measureUnit,
                    };
                    equipment.parameters.push(parameter);
                },
            );
            this.equipmentItem.buildingEquipments.forEach(buildingEquipment => {
                let dataCenterAux = equipment.dataCenters.filter(dataCenter => {
                    return dataCenter.id === buildingEquipment.buildingDataCenter.dataCenter.id;
                });
                if (!dataCenterAux || !dataCenterAux.length) {
                    let dataCenter: {
                        id: number;
                        name: string;
                        buildingDataCenter: {
                            id: number;
                            building: {
                                id: number;
                                name: string;
                            };
                        }[];
                    } = {
                        id: buildingEquipment.buildingDataCenter.dataCenter.id,
                        name: buildingEquipment.buildingDataCenter.dataCenter.name,
                        buildingDataCenter: [],
                    };
                    equipment.dataCenters.push(dataCenter);
                }
            });

            equipment.dataCenters.forEach(dataCenter => {
                let dataCentersList = this.equipmentItem.buildingEquipments.filter(
                    buildingEquipment => {
                        return dataCenter.id === buildingEquipment.buildingDataCenter.dataCenter.id;
                    },
                );

                if (dataCentersList && dataCentersList.length) {
                    dataCentersList.forEach(dataCenterItem => {
                        let buildingDataCenter: {
                            id: number;
                            building: {
                                id: number;
                                name: string;
                            };
                        } = {
                            id: dataCenterItem.buildingDataCenter.id,
                            building: {
                                id: dataCenterItem.buildingDataCenter.building.id,
                                name: dataCenterItem.buildingDataCenter.building.name,
                            },
                        };
                        dataCenter.buildingDataCenter.push(buildingDataCenter);
                    });
                }
            });
        }
        return equipment;
    }

    get options() {
        let options: {
            title: string;
            icon: string;
        }[] = [];

        if (this.updatePrivilege) {
            options.push({
                title: 'Modificar equipo',
                icon: 'mdi-monitor-edit',
            });
        }

        if (this.deletePrivilege) {
            options.push({
                title: 'Eliminar equipo',
                icon: 'mdi-server-off',
            });
        }

        return options;
    }

    get tabSize() {
        if (this.$vuetify.breakpoint.width < 1522) {
            return 8;
        } else {
            return 6;
        }
    }

    executeOptionFunction(option: string) {
        if (option === 'Modificar equipo') {
            this.updateEquipment(this.equipment);
        } else {
            if (option === 'Eliminar equipo') {
                let buildingEquipmentIds: number[] = [];
                this.equipmentItem.buildingEquipments.forEach(buildingEquipment => {
                    buildingEquipmentIds.push(buildingEquipment.id);
                });
                this.deleteEquipment(buildingEquipmentIds, this.equipment.name);
            }
        }
        this.menu = false;
    }
}
